import { light_offer_extended } from "@/lib/models/light_offer_extended";
import { offer } from "@/generated";
import isSpecialCoupon from "@/lib/util/isSpecialCoupon";
import is10PercentOffCoupon from "@/lib/util/is10PercentOffCoupon";
import isCouponOutOfRange from "@/lib/util/isCouponOutOfRange";

type OfferWithEndDate = (light_offer_extended | offer) & {
  clippable_dates?: string | string[] | null;
  ended_at?: string | Date | null;
};

function endOfDay(date: Date): Date {
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    23,
    59,
    59,
    999,
  );
}

export default function getOfferEndDate(
  offer: OfferWithEndDate,
  now: Date,
): Date {
  if (
    (isSpecialCoupon(offer as light_offer_extended) ||
      is10PercentOffCoupon(offer as light_offer_extended)) &&
    (offer as light_offer_extended).clippable_dates &&
    !isCouponOutOfRange(offer as light_offer_extended, now)
  ) {
    const clippableDates = (offer as light_offer_extended).clippable_dates;

    if (Array.isArray(clippableDates) && clippableDates.length > 0) {
      return endOfDay(new Date(clippableDates[clippableDates.length - 1]));
    }

    if (typeof clippableDates === "string") {
      return endOfDay(new Date(clippableDates));
    }
  }

  return new Date(offer.ended_at ?? now);
}
